import {
    FETCH_HEALTH_SNAPSHOT_SUMMARY_START,
    FETCH_HEALTH_SNAPSHOT_SUMMARY_SUCCESS,
    FETCH_HEALTH_SNAPSHOT_SUMMARY_FAIL,
    FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_START,
    FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_SUCCESS,
    FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_FAIL,
    FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_START,
    FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_SUCCESS,
    FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_FAIL,
    DELETE_HEALTH_SNAPSHOT_LIST_ITEM_START,
    DELETE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS,
    DELETE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL,
    UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_START,
    UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS,
    UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL,
    UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_START,
    UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_SUCCESS,
    UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_FAIL
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    healthSnapshots: null,
    healthSnapshotSummaryFetching: false,
    healthSnapshotSummarySuccess: false,
    healthSnapshotSummaryFail: false,
    healthSnapshotSummaryErrorType: null,
    healthSnapshotEpochDataFetching: false,
    healthSnapshotEpochDataSuccess: false,
    healthSnapshotEpochDataFail: false,
    healthSnapshotRelativeActivitiesFetching: false,
    healthSnapshotRelativeActivitiesSuccess: false,
    healthSnapshotRelativeActivitiesFail: false,
    healthSnapshotItemDeleting: false,
    healthSnapshotItemDeleteSuccess: false,
    healthSnapshotItemDeleteFail: false,
    healthSnapshotItemUpdating: false,
    healthSnapshotItemUpdateSuccess: false,
    healthSnapshotItemUpdateFail: false,
    healthSnapshotItemNoteUpdating: false,
    healthSnapshotItemUpdateNoteSuccess: false,
    healthSnapshotItemUpdateNoteFail: false
};

const healthSnapshotSummaryFetching = (state) => ({
    ...state,
    healthSnapshotSummaryFetching: true,
    healthSnapshotSummaryErrorType: null
});

const healthSnapshotSummaryFetchFinished = (isSuccess) => (state, action) => {
    const { activityUuid } = action.data;
    if (!action.data || !activityUuid) {
        return {
            ...state.healthSnapshots,
            healthSnapshotSummaryFetching: false,
            healthSnapshotSummaryFail: true,
            healthSnapshotSummaryErrorType: true
        };
    }

    const healthSnapshots = {
        ...state.healthSnapshots
    };

    if (!healthSnapshots[activityUuid.uuid]) {
        healthSnapshots[activityUuid.uuid] = {};
    }

    healthSnapshots[activityUuid.uuid].healthSnapshotSummary = isSuccess ? action.data : null;

    return {
        ...state,
        healthSnapshots,
        healthSnapshotSummaryFetching: false,
        healthSnapshotSummarySuccess: isSuccess,
        healthSnapshotSummaryFail: !isSuccess,
        healthSnapshotSummaryErrorType: !isSuccess && !action.data ? true : null
    };
};

const healthSnapshotEpochDataFetching = (state) => ({
    ...state,
    healthSnapshotEpochDataFetching: true
});

const healthSnapshotEpochDataFetchFinished = (isSuccess) => (state, action) => {
    const { activityUuid } = action.data;

    const healthSnapshots = {
        ...state.healthSnapshots
    };

    if (!healthSnapshots[activityUuid]) {
        healthSnapshots[activityUuid] = {};
    }

    healthSnapshots[activityUuid].healthSnapshotEpochData = isSuccess ? action.data : null;

    return {
        ...state,
        healthSnapshots,
        healthSnapshotEpochDataFetching: false,
        healthSnapshotEpochDataSuccess: isSuccess,
        healthSnapshotEpochDataFail: !isSuccess
    };
};

const healthSnapshotRelativeActivitiesFetching = (state, action) => {
    const activityUuid = action.payload;

    if (!state.healthSnapshots || !state.healthSnapshots[activityUuid]) {
        return state;
    }

    return {
        ...state,
        healthSnapshotRelativeActivitiesFetching: true
    };
};

const healthSnapshotRelativeActivitiesFetchFinished = (isSuccess) => (state, action) => {
    const { activityUuid } = action.payload;

    const healthSnapshots = {
        ...state.healthSnapshots
    };

    if (!healthSnapshots[activityUuid]) {
        healthSnapshots[activityUuid] = {};
    }

    healthSnapshots[activityUuid].healthSnapshotRelativeActivities = isSuccess ? action.data : null;

    return {
        ...state,
        healthSnapshots,
        healthSnapshotRelativeActivitiesFetching: false,
        healthSnapshotRelativeActivitiesSuccess: isSuccess,
        healthSnapshotRelativeActivitiesFail: !isSuccess
    };
};

const healthSnapshotItemDeleting = (state, action) => {
    const activityUuid = action.payload;

    if (!state.healthSnapshots || !state.healthSnapshots[activityUuid]) {
        return state;
    }

    return {
        ...state,
        healthSnapshotItemDeleting: true
    };
};

const healthSnapshotItemDeleteFinished = (isSuccess) => (state, action) => {
    const activityUuid = action.payload;

    if (!state.healthSnapshots || !state.healthSnapshots[activityUuid] || !isSuccess) {
        return state;
    }

    const healthSnapshots = {
        ...state.healthSnapshots
    };
    delete healthSnapshots[activityUuid];

    return {
        ...state,
        healthSnapshots,
        healthSnapshotItemDeleting: false,
        healthSnapshotItemDeleteSuccess: isSuccess,
        healthSnapshotItemDeleteFail: !isSuccess
    };
};

const healthSnapshotItemUpdating = (state, action) => {
    const { activityUuid } = action.payload;

    if (!state.healthSnapshots || !state.healthSnapshots[activityUuid]) {
        return state;
    }

    return {
        ...state,
        healthSnapshotItemUpdating: true
    };
};

const healthSnapshotItemUpdateFinished = (isSuccess) => (state, action) => {
    const { activityName, activityUuid } = action.payload;

    if (!state.healthSnapshots || !state.healthSnapshots[activityUuid] || !isSuccess) {
        return state;
    }

    const healthSnapshots = {
        ...state.healthSnapshots
    };

    healthSnapshots[activityUuid].healthSnapshotSummary = {
        ...healthSnapshots[activityUuid].healthSnapshotSummary,
        activityName
    };

    return {
        ...state,
        healthSnapshots,
        healthSnapshotItemUpdating: false,
        healthSnapshotItemUpdateSuccess: isSuccess,
        healthSnapshotItemUpdateFail: !isSuccess
    };
};

const healthSnapshotItemNoteUpdating = (state, action) => {
    const { activityUuid } = action.payload;

    if (!state.healthSnapshots || !state.healthSnapshots[activityUuid]) {
        return state;
    }

    return {
        ...state,
        healthSnapshotItemNoteUpdating: true
    };
};

const healthSnapshotItemNoteUpdateFinished = (isSuccess) => (state, action) => {
    const { activityNote, activityUuid } = action.payload;

    if (!state.healthSnapshots || !state.healthSnapshots[activityUuid] || !isSuccess) {
        return state;
    }

    const healthSnapshots = {
        ...state.healthSnapshots
    };

    healthSnapshots[activityUuid].healthSnapshotSummary = {
        ...healthSnapshots[activityUuid].healthSnapshotSummary,
        notes: activityNote
    };

    return {
        ...state,
        healthSnapshots,
        healthSnapshotItemNoteUpdating: false,
        healthSnapshotItemNoteUpdateSuccess: isSuccess,
        healthSnapshotItemNoteUpdateFail: !isSuccess
    };
};

export const isHealthSnapshotSummaryFetching = (state) => state.healthSnapshotDetails.healthSnapshotSummaryFetching;
export const isHealthSnapshotSummarySuccess = (state) => state.healthSnapshotDetails.healthSnapshotSummarySuccess;
export const isHealthSnapshotSummaryFail = (state) => state.healthSnapshotDetails.healthSnapshotSummaryFail;
export const getHealthSnapshotSummary = (state, activityUuid) => {
    const healthSnapshot =
        state.healthSnapshotDetails && state.healthSnapshotDetails.healthSnapshots
            ? state.healthSnapshotDetails.healthSnapshots[activityUuid]
            : null;
    return healthSnapshot ? healthSnapshot.healthSnapshotSummary : null;
};
export const getHealthSnapshotSummaryErrorType = (state) => state.healthSnapshotDetails.healthSnapshotSummaryErrorType;

export const getHealthSnapshotSummaryForCalendar = (state) => {
    return state.healthSnapshotDetails.healthSnapshots;
};

export const isHealthSnapshotEpochDataFetching = (state) => state.healthSnapshotDetails.healthSnapshotEpochDataFetching;
export const isHealthSnapshotEpochDataSuccess = (state) => state.healthSnapshotDetails.healthSnapshotEpochDataSuccess;
export const isHealthSnapshotEpochDataFail = (state) => state.healthSnapshotDetails.healthSnapshotEpochDataSuccess;
export const getHealthSnapshotEpochData = (state, activityUuid) => {
    const healthSnapshot =
        state.healthSnapshotDetails && state.healthSnapshotDetails.healthSnapshots
            ? state.healthSnapshotDetails.healthSnapshots[activityUuid]
            : null;
    return healthSnapshot ? healthSnapshot.healthSnapshotEpochData : null;
};

export const isHealthSnapshotRelativeActivitiesFetching = (state) =>
    state.healthSnapshotDetails.healthSnapshotRelativeActivitiesFetching;
export const isHealthSnapshotRelativeActivitiesSuccess = (state) =>
    state.healthSnapshotDetails.healthSnapshotRelativeActivitiesSuccess;
export const isHealthSnapshotRelativeActivitiesFail = (state) =>
    state.healthSnapshotDetails.healthSnapshotRelativeActivitiesFail;
export const getHealthSnapshotRelativeActivities = (state, activityUuid) => {
    const healthSnapshot =
        state.healthSnapshotDetails && state.healthSnapshotDetails.healthSnapshots
            ? state.healthSnapshotDetails.healthSnapshots[activityUuid]
            : null;
    return healthSnapshot ? healthSnapshot.healthSnapshotRelativeActivities : null;
};

export const isHealthSnapshotItemDeleting = (state) => state.healthSnapshotDetails.healthSnapshotItemDeleting;
export const isHealthSnapshotItemDeleteSuccess = (state) => state.healthSnapshotDetails.healthSnapshotItemDeleteSuccess;
export const isHealthSnapshotItemDeleteFail = (state) => state.healthSnapshotDetails.isHealthSnapshotItemDeleteFail;

export const isHealthSnapshotItemUpdating = (state) => state.healthSnapshotDetails.healthSnapshotItemUpdating;
export const isHealthSnapshotItemUpdateSuccess = (state) => state.healthSnapshotDetails.healthSnapshotItemUpdateSuccess;
export const isHealthSnapshotItemUpdateFail = (state) => state.healthSnapshotDetails.healthSnapshotItemUpdateFail;

export const isHealthSnapshotItemNoteUpdating = (state) => state.healthSnapshotDetails.healthSnapshotItemNoteUpdating;
export const isHealthSnapshotItemNoteUpdateSuccess = (state) =>
    state.healthSnapshotDetails.healthSnapshotItemNoteUpdateSuccess;
export const isHealthSnapshotItemNoteUpdateFail = (state) =>
    state.healthSnapshotDetails.healthSnapshotItemNoteUpdateFail;

const handlers = {
    [FETCH_HEALTH_SNAPSHOT_SUMMARY_START]: healthSnapshotSummaryFetching,
    [FETCH_HEALTH_SNAPSHOT_SUMMARY_SUCCESS]: healthSnapshotSummaryFetchFinished(true),
    [FETCH_HEALTH_SNAPSHOT_SUMMARY_FAIL]: healthSnapshotSummaryFetchFinished(false),

    [FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_START]: healthSnapshotEpochDataFetching,
    [FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_SUCCESS]: healthSnapshotEpochDataFetchFinished(true),
    [FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_FAIL]: healthSnapshotEpochDataFetchFinished(false),

    [FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_START]: healthSnapshotRelativeActivitiesFetching,
    [FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_SUCCESS]: healthSnapshotRelativeActivitiesFetchFinished(true),
    [FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_FAIL]: healthSnapshotRelativeActivitiesFetchFinished(false),

    [DELETE_HEALTH_SNAPSHOT_LIST_ITEM_START]: healthSnapshotItemDeleting,
    [DELETE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS]: healthSnapshotItemDeleteFinished(true),
    [DELETE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL]: healthSnapshotItemDeleteFinished(false),

    [UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_START]: healthSnapshotItemUpdating,
    [UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS]: healthSnapshotItemUpdateFinished(true),
    [UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL]: healthSnapshotItemUpdateFinished(false),

    [UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_START]: healthSnapshotItemNoteUpdating,
    [UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_SUCCESS]: healthSnapshotItemNoteUpdateFinished(true),
    [UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_FAIL]: healthSnapshotItemNoteUpdateFinished(false)
};

export default function healthSnapshotDetails(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
